<template>
  <section class="page-section">
        <!-- filter -->
        <div class="filter-region no-margin-top">
          <div class="filter-form">
            <el-form size="small" :inline="true" :model="filterForm" ref="filterForm">
              <el-form-item label="订单号：" prop="orderNo">
                <el-input v-model="filterForm.orderNo" placeholder="请输入" clearable></el-input>
              </el-form-item>
              <el-form-item label="交易流水号：" prop="transactionId">
                <el-input v-model="filterForm.transactionId" placeholder="请输入" clearable></el-input>
              </el-form-item>
              <el-form-item label="下单人昵称：" prop="userName">
                <el-input v-model="filterForm.userName" placeholder="请输入" clearable></el-input>
              </el-form-item>
              <el-form-item label="下单人ID：" prop="userId">
                <el-input v-model="filterForm.userId" placeholder="请输入" clearable></el-input>
              </el-form-item>
              <el-form-item label="收货人手机号：" prop="mobile">
                <el-input v-model="filterForm.mobile" placeholder="请输入" clearable></el-input>
              </el-form-item>
              <el-form-item label="顾客所属管家：" prop="serviceUserId">
                <el-select v-model="filterForm.serviceUserId" placeholder="请选择" clearable>
                  <el-option v-for="item in options" :key="item.id" :label="item.serviceUserName"
                    :value="item.serviceUserId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品名：" prop="commodityName">
                <el-autocomplete class="inline-input" v-model="filterForm.commodityName"
                  :fetch-suggestions="querySearch" :trigger-on-focus="false" placeholder="请输入" clearable></el-autocomplete>
              </el-form-item>
              <el-form-item label="代理商ID：" prop="companyId">
                <el-input v-model="filterForm.companyId" placeholder="请输入" clearable></el-input>
              </el-form-item>
              <el-form-item label="购买方式：" prop="isPoints">
                <el-select v-model="filterForm.isPoints" placeholder="请选择" clearable>
                  <el-option v-for="item in purchaseTypeOptions" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
               <el-form-item label="是否专链：" prop="isCommodityAgent">
                <el-select v-model="filterForm.isCommodityAgent" placeholder="请选择" clearable>
                  <el-option v-for="item in exclusiveLink" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="下单时间：" prop="orderTime" class="auto-width">
                <el-date-picker v-model="filterForm.orderTime" type="daterange" value-format="yyyy-MM-dd"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable>
                </el-date-picker>
              </el-form-item>
              <el-form-item label="发货时间：" prop="deliveryTime" class="auto-width">
                <el-date-picker v-model="filterForm.deliveryTime" type="daterange" value-format="yyyy-MM-dd"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable>
                </el-date-picker>
              </el-form-item>
              
              <el-form-item class="time-shortcut">
                <el-button plain @click="getLastFewDays(-7)"
                  :class="{ 'is-active': isActiveShortcut(-7) }">近7天</el-button>
                <el-button plain @click="getLastFewDays(-30)"
                  :class="{ 'is-active': isActiveShortcut(-30) }">近30天</el-button>
                  <el-button @click="exportOrder()" v-if="deriveListBtn">导出订单</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-btn">
            <el-button-group class="btn-group">
              <el-button plain class="btn-reset" icon="el-icon-refresh"
                @click="filterFormReset('filterForm')"></el-button>
              <el-button type="primary" class="btn-search" @click="filterFormSubmit('filterForm')"
                :loading="tableLoading">查询</el-button>
            </el-button-group>
          </div>
        </div>
        <div class="tab-account">
          <el-tabs class="mt-20 no-margin-top" v-model="tabName" type="card" @tab-click="handleTabsChange">
            <el-tab-pane label="全部" name="-2"></el-tab-pane>
            <el-tab-pane label="待付款" name="0"></el-tab-pane>
            <el-tab-pane label="待发货" name="1"></el-tab-pane>
            <el-tab-pane label="已发货" name="2"></el-tab-pane>
            <el-tab-pane label="已完成" name="4"></el-tab-pane>
            <el-tab-pane label="已关闭" name="-1"></el-tab-pane>
            <!-- <el-tab-pane label="退款中" name="5"></el-tab-pane> -->
            <!-- <el-tab-pane label="退款失败" name="6"></el-tab-pane> -->
            <!-- <el-tab-pane label="退款成功" name="7"></el-tab-pane> -->
          </el-tabs>
          <div class="trade-amount-box">
            <div class="trade-amount-card">
              <img src="../../../assets/actuallyPriceSum.png" class="card-icon" />
              <div class="card-content">
                <div class="card-header">
                  营收总额（元）
                </div>
                <div class="card-value">{{ tradeAmount.actuallyPriceSum }}</div>
              </div>
            </div>
            <div class="trade-amount-card">
              <img src="../../../assets/actuallyPricePoints.png" class="card-icon" />
              <div class="card-content">
                <div class="card-header">
                  积分营收总额（元）
                </div>
                <div class="card-value">{{ tradeAmount.actuallyPricePoints }}</div>
              </div>
            </div>
            <div class="trade-amount-card">
              <img src="../../../assets/actuallyPriceNotPoints.png" class="card-icon" />
              <div class="card-content">
                <div class="card-header">
                  商品营收总额（元）
                </div>
                <div class="card-value">{{ tradeAmount.actuallyPriceNotPoints }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- table -->
        <div class="table-region mt-10" v-loading="tableLoading">
          <!-- 自定义表格 -->
          <div class="custom-table">
            <div class="custom-table-header">
              <el-row :gutter="10">
                <el-col :span="6">
                  <div class="table-cell">商品</div>
                </el-col>
                <el-col :span="1">
                  <div class="table-cell">数量</div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">商品单价</div>
                </el-col>
                <el-col :span="1">
                  <div class="table-cell">是否专链</div>
                </el-col>
                <el-col :span="1">
                  <div class="table-cell">代理商ID</div>
                </el-col>
                <el-col :span="1">
                  <div class="table-cell">关联管家</div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">实付金额</div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">下单时间-发货时间</div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">下单人昵称-ID</div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell">收货人信息</div>
                </el-col>
                <el-col :span="1">
                  <div class="table-cell">订单状态</div>
                </el-col>
                <el-col :span="1">
                  <div class="table-cell">退款状态</div>
                </el-col>
                <el-col :span="2">
                  <div class="table-cell text-align-right">操作</div>
                </el-col>
              </el-row>
            </div>
            <div class="custom-table-body">
              <div class="no-data" v-if="tableData.length == 0">暂无数据</div>
              <!-- order item -->
              <div class="order-list-item" v-for="(item, index) in tableData" :key="index" v-else>
                <div class="item-header">
                  <el-row :gutter="10">
                    <el-col :span="22">
                      <div class="table-cell">
                        <el-row :gutter="10">
                          <el-col :span="24">
                            <p class="text">订单号：{{ item.orderNo }}</p>
                            <span style="margin-left: 20px;">交易流水号：{{ item.transactionId || '顾客未支付' }}</span>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="table-cell text-align-right">
                        <el-button type="text" size="small"
                          @click="pageNavigateToOrderOrderDetail(item)">查看详情</el-button>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div class="item-body">
                  <el-row :gutter="10">
                    <!-- 商品 -->
                    <el-col :span="7">
                      <div class="table-cell">
                        <el-row :gutter="10" v-for="(scope, index) in item.itemList" :key="index">
                          <el-col>
                            <div class="table-cell">
                              <div class="img-wrap" style="height: auto; align-items: center">
                                <div class="img-box">
                                  <img :src="scope.url">
                                </div>
                                <div style="flex: 1">
                                  <span class="text particular" style="height: auto">{{ scope.commodityName }}</span>
                                  <p class="text" style="" v-for="(it, index) in scope.skuList" :key="index">
                                    <span style="height: auto">{{ it.name }}：{{ it.value }}</span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                    <!-- 数量 -->
                    <el-col :span="1">
                      <div class="table-cell">
                        <div class="table-cell" style="height: 68px;" v-for="(scope, index) in item.itemList"
                          :key="index">
                          <div class="flex-v" style="justify-content: center;width: 100%;height: 100%;">
                            <p>{{ scope.num }}</p>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <!-- 商品单价 -->
                    <el-col :span="2">
                      <div class="table-cell">
                        <div class="table-cell" style="height: 68px;" v-for="(scope, index) in item.itemList"
                          :key="index">
                          <div class="flex-v" style="justify-content: center;width: 100%;height: 100%;">
                            <p>￥{{ scope.unitPrice }}</p>
                            <p>₩{{ scope.unitKoreaPrice }}</p>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <!-- 是否专链 -->
                    <el-col :span="1">
                      <div class="table-cell">
                        <div class="table-cell" style="height: 68px;" >
                          <div class="flex-v" style="justify-content: center;width: 100%;height: 100%;">
                            <p>{{ item.isCommodityAgent == 2 ? '是' : '否' }}</p>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <!-- 代理商ID -->
                    <el-col :span="1">
                      <div class="table-cell">
                        <div class="table-cell" style="height: 68px;" >
                          <div class="flex-v" style="justify-content: center;width: 100%;height: 100%;">
                            <p>{{ item.companyId || '-' }}</p>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <!-- 关联管家 -->
                    <el-col :span="1">
                      <div class="table-cell">
                        <p class="text">{{ item.serviceUserName }}</p>
                      </div>
                    </el-col>
                    <!-- 实付金额 -->
                    <el-col :span="2">
                      <div class="table-cell">
                        <p class="text">￥{{ item.actuallyPrice }}</p>
                      </div>
                    </el-col>
                    <!-- 下单时间-发货时间 -->
                    <el-col :span="2">
                      <div class="table-cell">
                        <p class="text">
                          下:{{ item.orderDate }}
                          <span v-if="item.deliveryTime"><br />发:{{ formatDeliveryTime(item.deliveryTime) }}</span>
                        </p>
                      </div>
                    </el-col>
                    <!-- 收货人昵称 -->
                    <el-col :span="2">
                      <div class="table-cell">
                        <p class="text">{{ item.userName }} </br> ID:{{ item.userId }}</p>
                      </div>
                    </el-col>
                    <!-- 收货人信息 -->
                    <el-col :span="2">
                      <div class="table-cell">
                        <p class="text">{{ item.receiverName }}</p>
                        <p class="text">{{ item.receiverPhone }}</p>
                        <p class="text particular">{{ item.addressDetail }}</p>
                      </div>
                    </el-col>
                    <!-- 订单状态 -->
                    <el-col :span="1">
                      <div class="table-cell">
                        <p class="text" v-if="item.status == -1">已关闭</p>
                        <p class="text" v-if="item.status == 0">待付款</p>
                        <p class="text" v-if="item.status == 1">待发货</p>
                        <p class="text" v-if="item.status == 2">已发货</p>
                        <p class="text" v-if="item.status == 4">已完成</p>
                        <p class="text" v-if="item.status == 9">退款中</p>
                        <p class="text" v-if="item.status == 10">退款成功</p>
                        <p class="text" v-if="item.status == 11">退款失败</p>
                      </div>
                    </el-col>
                    <!-- 退款状态 -->
                    <el-col :span="1">
                      <div class="table-cell">
                        {{ item.refundAmountType==1?'部分退款':item.refundAmountType==2?'全额退款':'--' }}
                      </div>
                    </el-col>
                    <!-- 操作 -->
                    <el-col :span="2">
                      <div class="table-cell text-align-right">
                        <!-- <el-button v-if="item.status == 0" type="text" size="small" @click="handleEditFreight(item)">修改运费</el-button> -->
                        <!-- <el-button v-if="item.status == 1" type="text" size="small" @click="handleDeliverGoods(item)">发货</el-button> -->
                        <p v-if="item.status == 2" class="text status-after">已发货</p>
                        <el-button v-if="item.status == 2" type="text" size="small"
                          @click="handleDeliverGoods(item)">修改物流信息</el-button>
                        <el-button v-if="item.status == 1" type="text" size="small"
                          @click="handleCancelOrder(item)">取消订单</el-button>
                        <el-button
                          v-if="(item.status == 2 || item.status == 4 || item.status == 11) && item.refundType == 1 && !item.refundAmountType" 
                          type="text" size="small" @click="handleReturnOrder(item, 1)">申请退款</el-button>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="table-footer" v-if="page.total > 0">
          <div class="selection-operate"></div>
          <div class="pagination-wrap">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :page-sizes="[20, 50, 100]" :pager-count="5" :current-page="page.current" :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper" :total="page.total">
            </el-pagination>
          </div>
        </div>

        <!-- 修改运费弹窗 -->
        <el-dialog title="修改运费" :visible.sync="dialogEditDeliverShow" width="400px">
          <el-form size="small" ref="formDialog" :model="formDialog" label-width="90px" class="dialog-form">
            <el-form-item label="配送方式">
              <p class="text">快递</p>
            </el-form-item>
            <el-form-item label="收货人">
              <p class="text">{{ formDialog.receiverName }} {{ formDialog.receiverPhone }}</p>
            </el-form-item>
            <el-form-item label="收货地址">
              <p class="text">{{ formDialog.addressDetail }}</p>
            </el-form-item>
            <el-form-item label="修改前运费">
              <p class="text">￥{{ formDialog.freightPrice }}</p>
            </el-form-item>
            <el-form-item label="修改后运费">
              <el-input type="number" class="w150" v-model="formDialog.freight">
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button size="small" plain @click="dialogEditDeliverShow = false">取 消</el-button>
            <el-button size="small" type="primary" @click="editDeliverGoods" :loading="dialogLoading">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 发货弹窗 -->
        <el-dialog title="订单发货" :visible.sync="dialogDeliverShow" width="400px">
          <el-form size="small" ref="formDialog" :model="formDialog" label-width="80px" class="dialog-form">
            <el-form-item label="收货人">
              <p class="text">{{ formDialog.receiverName }} {{ formDialog.receiverPhone }}</p>
            </el-form-item>
            <el-form-item label="收货地址">
              <p class="text">{{ formDialog.addressDetail }}</p>
            </el-form-item>
            <el-form-item label="快递公司">
              <el-select v-model="formDialog.deliverId" class="w200" placeholder="">
                <el-option v-for="(item, index) in formDialog.deliverCompany" :label="item.deliverName" :value="item.id"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="快递单号">
              <el-input v-model="formDialog.deliverNo" class="w200"></el-input>
            </el-form-item>
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button size="small" plain @click="dialogDeliverShow = false">取 消</el-button>
            <el-button size="small" type="primary" @click="deliverGoods" :loading="dialogLoading">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 申请退款/取消订单共用弹窗 -->
        <el-dialog :title="dialogReturnTitle" :visible.sync="dialogReturnShow" :width="dialogReturnTitle === '申请退款' && formDialog.refundTypeChoice === 1 ? '850px' : '450px'">
          <el-form size="small" ref="formDialog" :model="formDialog" label-width="130px" class="dialog-form">
            <template v-if="dialogReturnTitle === '申请退款'">
              <el-form-item label="请选择退款类型">
                <el-select v-model="formDialog.refundTypeChoice" class="w200" @change="handleRefundTypeChange" :disabled="dialogReturnTitle === '取消订单'">
                  <el-option label="部分退款" :value="1"></el-option>
                  <el-option label="全额退款" :value="2"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="退款金额">
                <el-input v-model="formDialog.refundPrice" type="number" class="w200" :disabled="true" :placeholder="formDialog.refundTypeChoice === 1 ? '根据输入退款金额自动累计' : ''"></el-input>
              </el-form-item>

              <el-form-item label="选择退款商品" v-if="formDialog.refundTypeChoice === 1" label-width="130px">
                <el-table :data="orderItemList" border style="width: 100%; max-height: 450px; overflow-y: auto;" @selection-change="handleSelectionChange" ref="refundTable">
                  <el-table-column type="selection" width="55" align="center"></el-table-column>
                  <el-table-column label="商品名称" min-width="180">
                    <template slot-scope="scope">
                      <span>{{ scope.row.commodityName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="单价/数量" width="120" align="center">
                    <template slot-scope="scope">
                      <span>￥{{ scope.row.unitPrice }} * {{ scope.row.num }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="退款金额" width="130" align="center">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.refundPrice"
                        type="number"
                        size="mini"
                        placeholder="请输入退款额"
                        @input="calculateTotalRefundPrice"
                        @blur="validateItemRefundPrice(scope.row)"
                      ></el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </template>
            <el-form-item :label="dialogReturnTitle === '取消订单' ? '取消原因' : '退款原因'">
              <el-input type="textarea" :rows="5" v-model="formDialog.refundReason" class="w200"></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" plain @click="dialogReturnShow = false">取 消</el-button>
            <el-button size="small" type="primary" @click="dialogReturnTitle === '取消订单' ? cancelOrder() : returnOrder()" :loading="dialogLoading">确 定</el-button>
          </span>
        </el-dialog>
      </section>
</template>
<script>
import {
  orderListCount,
  orderList,
  orderFreightEdit,
  orderDeliver,
  orderDeliverCompany,
  cancelReturnOrder,
  commodityNameList,
  COMMON,
  list,
  isLogin,
  orderExport
} from '../../../common/api'
export default {
  name: 'orderOrderList',
  data() {
    return {
      tabName: '-2', // 选项卡name 订单类型
      filterForm: { // 筛选表单值
        orderNo: '', // 订单号
        transactionId: '', // 交易流水号
        userName: '', // 下单人姓名
        userId: '', // 下单人ID
        mobile: '', // 手机号
        orderTime: '', // 下单时间起止点
        deliveryTime: '', // 发货时间起止点
        serviceUserId: '', // 管家id
        commodityName: '', // 商品名称
        companyId: '', // 代理商id
        isPoints: '', // 购买方式
        isCommodityAgent: '', // 是否专链
      },
      options: [], //管家
      purchaseTypeOptions: [{ label: '兑换', value: '1' }, { label: '购买', value: '0' }], //购买方式
      exclusiveLink: [{ label: '是', value: 2 }, { label: '否', value: 1 }], //是否专链
      page: { // 分页参数
        current: 1,
        size: 20,
        total: 0
      },
      tableLoading: true,
      tableData: [], // 表格数据
      goodsList: [], // 商品列表
      dialogEditDeliverShow: false, // 修改运费弹窗
      dialogDeliverShow: false, // 发货弹窗
      dialogReturnShow: false, // 申请退款弹窗
      dialogReturnTitle: '申请退款', // 弹窗标题
      dialogLoading: false,
      formDialog: {
        // 弹窗公用
        orderId: '', // 订单id
        status: '', // 订单状态值
        receiverName: '', // 收货人
        receiverPhone: '', // 收货手机号
        addressDetail: '', // 收货地址
        // 发货弹窗   
        deliverId: '', // 快递公司id
        deliverNo: '', // 快递单号 
        deliverCompany: [], // 快递公司列表           
        // 修改运费弹窗
        freightPrice: '', // 修改前运费
        freight: '', // 修改后运费
        // 取消订单/退款弹窗
        refundReason: '', // 取消订单/退款原因
        refundPrice: '', // 退款金额
        refundTypeChoice: 1, // 退款类型选择：1部分退款，2全额退款
        actuallyPrice: '', // 订单实付金额
        refundType: '' // 退款接口类型：1申请退款，2取消订单
      },
      tradeAmount: {},
      orderItemList:[],
      selectedRefundItems: [],
      deriveListBtn:false
    }
  },
  methods: {
    // 导出订单
    async exportOrder() {
      await this.getBtnLimits();
      if (!this.deriveListBtn) {
        this.$message.warning('暂无导出权限');
        return;
      }
      let param = {
        "orderNo": this.filterForm.orderNo,
        "transactionId": this.filterForm.transactionId,
        'userName': this.filterForm.userName,
        'userId': this.filterForm.userId,
        "mobile": this.filterForm.mobile,
        "startDate": this.filterForm.orderTime ? this.filterForm.orderTime[0] : '',
        "endDate": this.filterForm.orderTime ? this.filterForm.orderTime[1] : '',
        "deliveryTimeStartDate": this.filterForm.deliveryTime ? this.filterForm.deliveryTime[0] : '',
        "deliveryTimeEndDate": this.filterForm.deliveryTime ? this.filterForm.deliveryTime[1] : '',
        'commodityName': this.filterForm.commodityName,
        'isPoints': this.filterForm.isPoints,
        "serviceUserId": this.filterForm.serviceUserId,
        'isCommodityAgent': this.filterForm.isCommodityAgent,
        'companyId': this.filterForm.companyId,
      }
      if (Number(this.tabName) != -2) {
        param.status = Number(this.tabName);
      }
      const loading = this.$loading({
        lock: true,
        text: '正在导出订单，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      orderExport(param).then(res => {
        console.log(res)
        // 从 response headers 中提取文件名
        let fileName = '订单导出数据.xlsx';
        const disposition = res.headers && res.headers['content-disposition'];
        if (disposition) {
          const utf8FilenameRegex = /filename\*=utf-8''([^;\n]+)/i;
          const utf8Matches = utf8FilenameRegex.exec(disposition);
          if (utf8Matches && utf8Matches[1]) {
            fileName = decodeURIComponent(utf8Matches[1]);
          } else {
            const filenameRegex = /filename=([^;\n]+)/i;
            const matches = filenameRegex.exec(disposition);
            if (matches && matches[1]) {
              fileName = decodeURIComponent(matches[1].replace(/['"]/g, ''));
            }
          }
        }

        // 创建 Blob 接收文件流并模拟点击下载
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(downloadUrl);
        this.$message.success('导出成功');
      }).catch(error => {
        console.error(error);
        this.$message.error("导出失败");
      }).finally(() => {
        loading.close();
      });
    },
    // 控制导出按钮显隐
    async getBtnLimits() {
      try {
        let res = await isLogin();
        if (res.code !== 0) {
          this.$message.error(res.msg);
          this.deriveListBtn = false;
          localStorage.clear();
          this.$router.push({ path: "/login" });
        } else {
          const ids = res.data || [];
          if (localStorage.getItem("ids") !== JSON.stringify(ids)) {
            localStorage.setItem("ids", JSON.stringify(ids));
          }
          // 直接使用 includes 判断数组中是否包含数值 1001，防止模糊匹配 Bug
          this.deriveListBtn = ids.includes(1001);
        }
      } catch (err) {
        console.error(err);
        this.deriveListBtn = false;
        this.$message.error("获取权限失败，请检查网络");
      }
    },
    // 格式化发货时间
    formatDeliveryTime(time) {
      if (!time) return '';
      return COMMON.formatDate(2, '-', time);
    },
    // 获取管家列表
    getManagerList() {
      list().then(res => {
        if (res.data.length === 0) {
          this.$message.error('暂无管家信息');
          return;
        }
        this.options = res.data;
      }).catch(() => {
        this.$message.error('获取管家列表失败');
      })
    },
    // 获取商品名列表
    getCommodityNameList () {
      this.goodsList = [];
      commodityNameList().then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          for (let i in data) {
            this.goodsList.push({ value: data[i] });
          }
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      })
    },
    // 获取快递公司
    getDeliverCompanyList () {
      orderDeliverCompany().then(res => {
        let { code, data, msg } = res;
        if (code == 0) {
          this.formDialog.deliverCompany = data || [];
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      })
    },
    // 获取订单统计
    getOrderListCount() {
      let param = {
        "orderNo": this.filterForm.orderNo,
        "transactionId": this.filterForm.transactionId,
        'userName': this.filterForm.userName,
        'userId': this.filterForm.userId,
        "mobile": this.filterForm.mobile,
        "startDate": this.filterForm.orderTime ? this.filterForm.orderTime[0] : '',
        "endDate": this.filterForm.orderTime ? this.filterForm.orderTime[1] : '',
        "deliveryTimeStartDate": this.filterForm.deliveryTime ? this.filterForm.deliveryTime[0] : '',
        "deliveryTimeEndDate": this.filterForm.deliveryTime ? this.filterForm.deliveryTime[1] : '',
        'commodityName': this.filterForm.commodityName,
        "serviceUserId": this.filterForm.serviceUserId,
        'isPoints': this.filterForm.isPoints,
        'isCommodityAgent': this.filterForm.isCommodityAgent,
        'companyId': this.filterForm.companyId,
      }
      orderListCount(param).then(res => {
        let { code, data, msg } = res;
        if (code == 0) {
          this.tradeAmount = data;
        } else {
          this.$message.error(msg);
        }
      })
    },
    // 获取表格数据
    getList() {
      this.tableLoading = true;
      let param = {
        "orderNo": this.filterForm.orderNo,
        "transactionId": this.filterForm.transactionId,
        'userName': this.filterForm.userName,
        'userId': this.filterForm.userId,
        "mobile": this.filterForm.mobile,
        "startDate": this.filterForm.orderTime ? this.filterForm.orderTime[0] : '',
        "endDate": this.filterForm.orderTime ? this.filterForm.orderTime[1] : '',
        "deliveryTimeStartDate": this.filterForm.deliveryTime ? this.filterForm.deliveryTime[0] : '',
        "deliveryTimeEndDate": this.filterForm.deliveryTime ? this.filterForm.deliveryTime[1] : '',
        'commodityName': this.filterForm.commodityName,
        'isPoints': this.filterForm.isPoints,
        "serviceUserId": this.filterForm.serviceUserId,
        'isCommodityAgent': this.filterForm.isCommodityAgent,
        'companyId': this.filterForm.companyId,
        "current": this.page.current,
        "size": this.page.size
      }
      if (Number(this.tabName) != -2) {
        param.status = Number(this.tabName);
      }
      console.log(param)
      orderList(param).then(res => {
        this.tableLoading = false;
        let { code, data, msg } = res;
        if (code == 0) {
          this.tableData = data.records || [];
          this.page.total = data.total;
          this.$nextTick(() => {
            const scrollContainer = document.querySelector('.app-container');
            if (scrollContainer) {
              scrollContainer.scrollTop = 0;
            }
          });
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.tableLoading = false;
        this.$message.error('服务器异常');
      })
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择表格第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    // 切换选项卡
    handleTabsChange: function (tab, event) {
      // this.filterFormReset('filterForm');
      this.page.current = 1;
      this.page.size = 20;
      this.getList();
    },
    // 提交筛选表单
    filterFormSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.page.current = 1;
          this.page.size = 20
          this.getList();
          this.getOrderListCount();
        } else {
          return false;
        }
      });
    },
    // 重置筛选表单
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
    },
    // 查看订单详情
    pageNavigateToOrderOrderDetail: function (item) {
      this.$router.push({ path: '/order/order/detail', query: { id: item.id } })
    },
    // 打开修改运费弹窗
    handleEditFreight: function (item) {
      this.formDialog.freight = '';
      this.formDialog.orderId = item.id;
      this.formDialog.receiverName = item.receiverName;
      this.formDialog.receiverPhone = item.receiverPhone;
      this.formDialog.addressDetail = item.addressDetail;
      this.formDialog.freightPrice = item.freightPrice;
      this.dialogEditDeliverShow = true;
    },
  // 修改运费
    editDeliverGoods: function () {
      if (this.formDialog.freight == '') {
        this.$message.error('请输入修改后的运费');
        return false;
      }
      this.dialogLoading = true;
      let param = {
        'id': this.formDialog.orderId,
        'freight': this.formDialog.freight
      }
      orderFreightEdit(param).then(res => {
        this.dialogLoading = false;
        this.dialogEditDeliverShow = false;
        let { code, data, msg } = res;
        if (code == 0) {
          this.$message.success('修改成功');
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
        this.dialogLoading = false;
        this.dialogEditDeliverShow = false;
      })
    },
    // 打开发货弹窗
    handleDeliverGoods: function (item) {
      this.formDialog.deliverId = '';
      this.formDialog.deliverNo = '';

      if (item.status == 2) {
        this.formDialog.deliverId = Number(item.deliverId);
        this.formDialog.deliverNo = item.deliverNo;
      }
      this.formDialog.orderId = item.id;
      this.formDialog.status = item.status;
      this.formDialog.receiverName = item.receiverName;
      this.formDialog.receiverPhone = item.receiverPhone;
      this.formDialog.addressDetail = item.addressDetail;
      this.dialogDeliverShow = true;
    },
    // 发货弹窗切换配送方式
    changeDeliveryWay: function (val) {
      this.formDialog.deliverId = '';
      this.formDialog.deliverNo = '';
    },
    // 确认发货
    deliverGoods: function () {
      if (this.formDialog.deliverId == '') {
        this.$message.error('请选择快递公司');
        return false;
      }
      if (this.formDialog.deliverNo == '') {
        this.$message.error('请输入快递单号');
        return false;
      }
      this.dialogLoading = true;
      let param = {
        'orderId': this.formDialog.orderId,
        'deliverId': this.formDialog.deliverId,
        'deliverNo': this.formDialog.deliverNo,
        'type': this.formDialog.status == 2 ? 2 : 1
      }
      orderDeliver(param).then(res => {
        this.dialogLoading = false;
        this.dialogDeliverShow = false;
        let { code, data, msg } = res;
        if (code == 0) {
          this.$message.success('发货成功');
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
        this.dialogLoading = false;
        this.dialogDeliverShow = false;
      })
    },
    // 打开取消订单弹窗
    handleCancelOrder (item) {
      this.formDialog.orderId = item.id;
      this.formDialog.actuallyPrice = item.actuallyPrice;
      this.formDialog.refundTypeChoice = 2; // 固定为全额退款
      this.formDialog.refundPrice = item.actuallyPrice; // 自动填充全额退款金额
      this.formDialog.refundReason = '';
      this.dialogReturnTitle = '取消订单';
      this.dialogReturnShow = true;
    },
    // 取消订单
    cancelOrder: function () {
      if (!this.formDialog.refundPrice || Number(this.formDialog.refundPrice) <= 0) {
        this.$message.error('请输入合法的退款金额');
        return false;
      }
      let param = {
        'orderId': this.formDialog.orderId,
        'refundReason': this.formDialog.refundReason,
        'refundPrice': this.formDialog.refundPrice,
        'refundType': 2,
        'refundAmountType': this.formDialog.refundTypeChoice
      }
      this.dialogLoading = true;
      cancelReturnOrder(param).then(res => {
        this.dialogLoading = false;
        this.dialogReturnShow = false;
        let { code, data, msg } = res;
        if (code == 0) {
          this.$message.success('取消成功');
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
        this.dialogLoading = false;
        this.dialogReturnShow = false;
      })
    },
  //  打开申请退款弹窗
    handleReturnOrder: function (item, type = 1) {
      this.formDialog.orderId = item.id;
      this.formDialog.actuallyPrice = item.actuallyPrice;
      this.formDialog.refundTypeChoice = 1;
      this.formDialog.refundPrice = '';
      this.formDialog.refundReason = '';
      this.formDialog.refundType = type;
      this.dialogReturnTitle = '申请退款';
      this.dialogReturnShow = true;
      
      const list = item.itemList ? JSON.parse(JSON.stringify(item.itemList)) : [];
      list.forEach(val => {
        this.$set(val, 'refundPrice', '');
      });
      this.orderItemList = list;
      this.selectedRefundItems = [];
    },
    handleRefundTypeChange(val) {
      if (val === 2) {
        this.formDialog.refundPrice = this.formDialog.actuallyPrice;
      } else {
        this.calculateTotalRefundPrice();
      }
    },
    handleSelectionChange(val) {
      this.selectedRefundItems = val;
      this.calculateTotalRefundPrice();
    },
    calculateTotalRefundPrice() {
      let total = 0;
      this.selectedRefundItems.forEach(item => {
        if (item.refundPrice) {
          total += Number(item.refundPrice);
        }
      });
      this.formDialog.refundPrice = total > 0 ? Number(total.toFixed(2)) : '';
    },
    validateItemRefundPrice(row) {
      if (row.refundPrice !== '' && row.refundPrice !== undefined && row.refundPrice !== null) {
        let val = Number(row.refundPrice);
        if (val <= 0) {
          this.$message.error(`商品“${row.commodityName}”的退款金额必须大于 0`);
          row.refundPrice = '';
          this.calculateTotalRefundPrice();
          return false;
        }
        let maxPrice = Number((row.unitPrice * row.num).toFixed(2));
        if (val > maxPrice) {
          this.$message.error(`商品“${row.commodityName}”的退款金额不能大于商品价格￥${maxPrice}`);
          row.refundPrice = '';
          this.calculateTotalRefundPrice();
          return false;
        }
      }
    },
    // 申请
    returnOrder() {
      if (this.formDialog.refundTypeChoice === 1) {
        // 部分退款校验商品选择与金额
        if (!this.selectedRefundItems || this.selectedRefundItems.length === 0) {
          this.$message.error('请选择退款商品');
          return false;
        }
        for (let i = 0; i < this.selectedRefundItems.length; i++) {
          let item = this.selectedRefundItems[i];
          if (!item.refundPrice || Number(item.refundPrice) <= 0) {
            this.$message.error(`请输入商品“${item.commodityName}”的退款金额`);
            return false;
          }
          let maxPrice = Number((item.unitPrice * item.num).toFixed(2));
          if (Number(item.refundPrice) > maxPrice) {
            this.$message.error(`商品“${item.commodityName}”的退款金额不能大于商品价格￥${maxPrice}`);
            return false;
          }
        }
      }

      if (!this.formDialog.refundPrice || Number(this.formDialog.refundPrice) <= 0) {
        this.$message.error('请输入合法的退款金额');
        return false;
      }
      if (this.formDialog.refundTypeChoice === 1 && Number(this.formDialog.refundPrice) > Number(this.formDialog.actuallyPrice)) {
        this.$message.error('部分退款金额不能大于订单金额（￥' + this.formDialog.actuallyPrice + '）');
        return false;
      }
      let param = {
        'orderId': this.formDialog.orderId,
        'refundReason': this.formDialog.refundReason,
        'refundPrice': this.formDialog.refundPrice,
        'refundType': this.formDialog.refundType,
        'refundAmountType': this.formDialog.refundTypeChoice
      }

      if (this.formDialog.refundTypeChoice === 1) {
        const refundItems = this.selectedRefundItems.map(item => ({
          orderItemId: item.orderItemId,
          price: Number(item.refundPrice)
        }));
        param.refundItems = refundItems;
      }
      // console.log(this.formDialog.refundTypeChoice)
      // console.log(param)
      // return
      this.dialogLoading = true;
      cancelReturnOrder(param).then(res => {
        this.dialogLoading = false;
        this.dialogReturnShow = false;
        let { code, data, msg } = res;
        if (code == 0) {
          this.$message.success('申请成功');
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
        this.dialogLoading = false;
        this.dialogReturnShow = false;
      })
    },
    // 获取近几日日期
    getLastFewDays: function (day) {
      const start = COMMON.getDay(day);
      const end = COMMON.getDay(0);
      this.filterForm.orderTime = [start, end];
      this.filterForm.deliveryTime = [start, end];
    },
    // 判断时间快捷选项是否处于选中状态
    isActiveShortcut(day) {
      const orderTimeMatch = this.filterForm.orderTime && this.filterForm.orderTime.length === 2 &&
        this.filterForm.orderTime[0] === COMMON.getDay(day) && this.filterForm.orderTime[1] === COMMON.getDay(0);
      const deliveryTimeMatch = this.filterForm.deliveryTime && this.filterForm.deliveryTime.length === 2 &&
        this.filterForm.deliveryTime[0] === COMMON.getDay(day) && this.filterForm.deliveryTime[1] === COMMON.getDay(0);
      return orderTimeMatch && deliveryTimeMatch;
    },
    // 商品搜索联想
    querySearch(queryString, cb) {
      var goodsList = this.goodsList;
      var results = queryString ? goodsList.filter(this.createFilter(queryString)) : goodsList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (goodsList) => {
        return (goodsList.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    }
  },
  mounted() {
    this.getCommodityNameList();
    this.getDeliverCompanyList();
    this.getManagerList();
    this.getList();
    this.getOrderListCount();
  },
  activated() {
    this.getBtnLimits();
  }
}
</script>
<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";

.mr-10 {
  margin-right: 10px;
}

.mt-20 {
  margin-top: 20px;
}

.mt-10 {
  margin-top: 10px !important;
}

.dialog-body-title {
  text-indent: 15px;
  margin-bottom: 10px;
  font-size: $baseFS;
}

.filter-region {
  // flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;
  justify-content: space-between;

  .el-form-item {
    &.time-shortcut {
      background: initial;
      padding: 0;

      :deep(.el-form-item__content) {
        width: auto;

        .el-button {
          width: 110px;
          height: 40px;
          border-radius: 5px;

          &.is-active {
            border: 1px solid #3388FF;
            color: #3388FF;
            background-color: #ecf5ff;
          }
        }
      }
    }
  }


  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        &+.el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}

.tab-account {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // flex-wrap: wrap;
  height: 80px;

  .trade-amount-box {
    display: flex;
    align-items: stretch;

    .trade-amount-card {
      height: 60px;
      padding: 10px;
      border-radius: 6px;
      margin: 0 7px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      background: #F1F7FF;

      .card-icon {
        width: 24px;
        height: 24px;
        margin-right: 12px;
      }

      .card-content {
        display: flex;
        flex-direction: column;

        .card-header {
          line-height: 17px;
          font-size: 14px;
          color: #888;

        }

        .card-value {
          line-height: 25px;
          font-size: 18px;
          color: #666666;
          font-weight: 600;
        }
      }
    }
  }
}


.table-region {
  // margin-bottom: 50px;

  .custom-table {

    .custom-table-header {
      padding-right: 4px;
      text-align: center;
      scrollbar-gutter: stable;
    }

    .custom-table-body {
      padding-right: 4px;
      text-align: center;

      .particular {
        text-align: left;
      }
    }
  }

}
</style>
